import { useEffect } from "react";
import { EmployerHero } from "@/components/employer/EmployerHero";
import { ValueProps } from "@/components/employer/ValueProps";
import { Industries } from "@/components/landing/Industries";
import { ProcessTimeline } from "@/components/employer/ProcessTimeline";
import { EmployerTypes } from "@/components/employer/EmployerTypes";
import { RequirementForm } from "@/components/employer/RequirementForm";
import { DirectContact } from "@/components/employer/DirectContact";
import { Trust } from "@/components/landing/Trust";
import { EmployerFinalCTA } from "@/components/employer/EmployerFinalCTA";

export default function RecruitmentPage() {
    useEffect(() => {
        const previous = document.title;
        document.title = "Employer Recruitment | Afrinexa Global";
        return () => {
            document.title = previous;
        };
    }, []);

    return (
        <>
            <EmployerHero />
            <ValueProps />
            <Industries
                intro="We support workforce requirements across a broad range of sectors."
                layout="grid"
            />
            <ProcessTimeline />
            <EmployerTypes />
            <RequirementForm />
            <DirectContact />
            <Trust />
            <EmployerFinalCTA />
        </>
    );
}
